import { FormStep } from '@/hooks/useTrackFormProgress'

enum SessionStorageKey {
  FormStartLogged = 'form_start_logged',
  FormStepName = 'form_step_name',
  FormStepIndex = 'form_step_index',
}

const storageFormStepName = {
  get: () => sessionStorage.getItem(SessionStorageKey.FormStepName) || '',
  set: (value: FormStep) =>
    sessionStorage.setItem(SessionStorageKey.FormStepName, value),
}

const storageFormStepIndex = {
  get: () =>
    parseInt(sessionStorage.getItem(SessionStorageKey.FormStepIndex) || '1'),
  set: (value: number) =>
    sessionStorage.setItem(SessionStorageKey.FormStepIndex, value.toString()),
}

const storageFormStartLogged = {
  get: () => sessionStorage.getItem(SessionStorageKey.FormStartLogged),
  set: () => sessionStorage.setItem(SessionStorageKey.FormStartLogged, 'true'),
}

// Not in SessionStorageKey on purpose: clearSessionStorage runs on every page
// load (App.tsx) and on form completion, and this flag must survive both.
const insuranceNoticeDismissedKey = 'insurance_notice_dismissed'

const storageInsuranceNoticeDismissed = {
  get: () => sessionStorage.getItem(insuranceNoticeDismissedKey) === 'true',
  set: () => sessionStorage.setItem(insuranceNoticeDismissedKey, 'true'),
}

const clearSessionStorage = () => {
  Object.values(SessionStorageKey).forEach((key) =>
    sessionStorage.removeItem(key),
  )
}
export {
  clearSessionStorage,
  SessionStorageKey,
  storageFormStartLogged,
  storageFormStepIndex,
  storageFormStepName,
  storageInsuranceNoticeDismissed,
}
